import { Controller, useForm } from "react-hook-form";
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Grid, MenuItem, TextField, InputAdornment } from "@material-ui/core";
import CreateCancel from "../../atoms/buttons/CreateCancel";
import { basic, validationMessages, requiredOnly, requiredOnlyMessage } from '../../../config/validations';
import { invokePostService, invokeGetService } from '../../../store/global/actions';
import { findRelativePosition } from '../../../services/reactFlowService';
import { validateNonAsciiChars } from "../../../utils/commonUtils";

export const CreateDelegateForm = (props) => {

    const { onClose, onCompletion, clusterletDetails } = props;
    const { register, getValues, trigger, reset, formState: { errors }, control, handleSubmit, setError } = useForm();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
    const [delegateTypes, setDelegateTypes] = useState([]);

    const messages = {
        ...validationMessages,
        ...requiredOnlyMessage,
        validate: 'This name is already used'
    };

    useEffect(() => {
        fetchDelegateTypes();
    }, [])

    const fetchDelegateTypes = () => {
        setIsFetching(true);
        dispatch(invokeGetService('getDelegateProtocols', [])).then(res => {
            if (res.status && res.data) {
                const modifiedDelegateTypes = res.data.map(item => ({ label: item.schemaJson?.desc, value: item.node }));
                setDelegateTypes(modifiedDelegateTypes);
            }
            setIsFetching(false);
        });
    }

    const onCreate = ({ name, description, type, network, ports }) => {
        setLoading(true);


        clusterletDetails.name = name;
        clusterletDetails.attributes.desc = description;
        clusterletDetails.attributes.type = type;
        clusterletDetails.attributes.network = network;

        if (ports != '') {
            clusterletDetails.attributes.ports = ports.split(",").map(Number);
        }

        const position = findRelativePosition(clusterletDetails.position, clusterletDetails.type);
        clusterletDetails.position = position;

        dispatch(invokePostService('createDelegate', { clusterlet: clusterletDetails })).then(res => {
            setLoading(false);
            if (res?.status) {
                onCompletion(true);
            } else {
                if (res?.code === "600") {
                    res?.errors?.forEach(error => {
                        setError(error.name, { message: error.message });
                    });
                }
            }
        })
    }


    const validateNumbers = (value) => {
        if (!value) {
            return true; // Allow empty value
        }
        const numericValues = value
            .split(',')
            .map((part) => part.trim())
            .filter((part) => /^-?\d+$/.test(part));

        if (numericValues.length === 0 || numericValues.length !== value.split(',').length) {
            return 'Please enter only numeric values separated by commas.';
        }

        return true;
    };

    return (
        <Grid container direction={"row"} spacing={3}>
            <Grid item xs={12}>
                <TextField
                    name="name"
                    autoFocus
                    fullWidth
                    type={"text"}
                    required={true}
                    label={"Name"}
                    placeholder={""}
                    variant="outlined"
                    inputRef={register({ ...basic })}
                    error={errors?.name ? true : false}
                    helperText={errors?.name ? errors?.name?.message ? errors?.name?.message : messages[errors?.name?.type] : ''}
                />
            </Grid>

            <Grid item xs={12}>
                <TextField
                    id="description"
                    type={"text"}
                    fullWidth
                    rows={4}
                    label={"Description"}
                    placeholder={"Description"}
                    variant="outlined"
                    name="description"
                    inputRef={register({ required: false, validate: validateNonAsciiChars })}
                    error={errors?.description}
                    helperText={errors?.description?.message || ''}
                    multiline={true}
                />
            </Grid>

            <Grid item xs={12} style={{ zIdex: 2000 }}>
                <Controller
                    name="type"
                    control={control}
                    rules={{ required: true, requiredOnly }}
                    render={({ field, onChange }) =>
                        <TextField
                            {...field}
                            label={'Type'}
                            name="type"
                            select
                            fullWidth
                            required
                            variant={'outlined'}
                            onChange={onChange}
                            error={errors?.type ? true : false}
                            helperText={messages[errors?.type?.type] || ''}
                            SelectProps={{
                                MenuProps: {
                                  MenuListProps: {
                                    id: "type-menu-list", 
                                  },
                                },
                              }}
                            InputProps={{
                                startAdornment: isFetching ? (
                                  <InputAdornment position="start" style={{width: "100%"}}>
                                    Loading types, please wait..
                                  </InputAdornment>
                                ) : null,
                              }}
                        >
                            <MenuItem key={123} value={""}>Select type</MenuItem>
                            {delegateTypes.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    }
                />

            </Grid>

            <Grid item xs={12}>
                <TextField
                    name="network"
                    label="Network"
                    required={true}
                    variant={'outlined'}
                    fullWidth
                    inputRef={register({ ...basic })}
                    error={errors?.network ? true : false}
                    helperText={errors?.network ? messages[errors?.network?.type] : ''}
                />
            </Grid>

            <Grid item xs={12} >
                <TextField
                    name="ports"
                    label="Ports"
                    required={false}
                    variant={'outlined'}
                    fullWidth
                    inputRef={register({ validate: validateNumbers })}
                    error={errors?.ports ? true : false}
                    helperText={errors?.ports ? errors.ports?.message ? errors.ports.message : messages[errors?.ports?.type] : 'Use commas to sepearte ports. eg: 8080,8068'}
                />
            </Grid>


            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginBottom: 20 }}>
                <CreateCancel createDisable={loading} content={loading ? 'Creating..' : 'Create'} onCreate={handleSubmit(onCreate)} onCancel={onClose} />
            </Grid>
        </Grid>
    );

}